import { escapeCsv } from "../../utils/formatters";
import { money, neutralize, usDate } from "./quickbooksInvoiceCsv";

// The Reconciliation tab's CSV (DEV-2926), from the rows of migration 109: one
// line per advertiser per UTC activity day. Pure, so it is tested on its own.
// All amounts arrive as integer cents, so the differences never drift.

export const RECONCILIATION_COLUMNS = [
  "Date", "Advertiser ID", "Advertiser", "Billable Conversions", "Billable Amount", "Charged Conversions",
  "Charged Amount", "Difference", "Running Difference", "Charge Dated This Day", "Reason",
];

const REASON_LABELS = {
  not_charged_yet: "Not charged yet",
  not_charged_skipped: "No charge linked, past the auto-charge window",
  not_on_auto_charge: "Not on auto-charge",
  auto_charge_paused: "Auto-charge paused",
  charged_then_credited: "Charged, then credited",
  credited_never_charged: "Credited, never charged",
  no_longer_billable: "Charged, no longer billable",
  charged_twice: "Charged twice",
  charged_different_amount: "Charged a different amount",
  charge_covers_other_days: "This day's charge covers other days",
};

function reasonLabel({ reason, charge_day: chargeDay }) {
  if (reason === "charged_different_day") return `Charged on ${usDate(chargeDay)}`;
  return REASON_LABELS[reason] ?? reason;
}

function reasonText(reasons) {
  return reasons
    .map((r) => `${reasonLabel(r)}: ${r.count} ${r.count === 1 ? "conversion" : "conversions"}, $${money(r.cents)}`)
    .join("; ");
}

function byAdvertiserAndDay(a, b) {
  return a.advertiser_id - b.advertiser_id || a.day.localeCompare(b.day);
}

export function buildReconciliationCsv(rows) {
  let advertiserId = null;
  let running = 0;
  const lines = [...rows].sort(byAdvertiserAndDay).map((row) => {
    if (row.advertiser_id !== advertiserId) {
      advertiserId = row.advertiser_id;
      running = 0;
    }
    const difference = row.billable_cents - row.charged_cents;
    running += difference;
    return [
      usDate(row.day), row.advertiser_id, neutralize(row.advertiser_name), row.billable_count, money(row.billable_cents),
      row.charged_count, money(row.charged_cents), money(difference), money(running), money(row.charge_dated_cents),
      reasonText(row.reasons),
    ];
  });
  // The BOM lets a spreadsheet read accented names correctly.
  return `\uFEFF${[RECONCILIATION_COLUMNS, ...lines].map((cells) => cells.map(escapeCsv).join(",")).join("\r\n")}\r\n`;
}
